import bypass from "@/components/popups/bypass";
import PostOpReview from "@/components/popups/PostOpReview";
import review from "@/components/popups/review";
import tower from "@/components/popups/tower";
import { navigationNamespace } from "@/store/modules/navigation";
import { Patient } from "@/store/modules/patient/types";
import "swiper/dist/css/swiper.css";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";

const patientNamespace = { namespace: "patient" };

// do we need PostOpReview here?
@Component({
  components: { tower, review, bypass, PostOpReview }
})
export default class Tower extends Vue {
  @Action("fetchBodyData", patientNamespace)
  fetchBodyData!: Function;

  @Getter("darkMode", navigationNamespace)
  dark!: boolean;

  @Getter("config", patientNamespace)
  config!: any;

  @Getter("current", patientNamespace)
  current!: Patient;

  @Prop(Number)
  room!: number;

  @Prop(String)
  area!: string;

  @Prop(String)
  page!: string;

  async created() {
    await this.fetchBodyData(this.room);
  }
}
